module.exports = __webpack_public_path__ + "static/img/图文5.aa696a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/图文5.jpg
// module id = svre
// module chunks = 1